export default __webpack_public_path__ + "static/media/weight-mate-ios.40e931c2.png";